import UIApplication from 'UIComponents/app/UIApplication';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error untyped loader
import { name as packageName } from 'current-package-loader!';
import { renderAppRoot } from './root-renderer';
import { jsx as _jsx } from "react/jsx-runtime";
function InternalAuthErrorPage() {
  return /*#__PURE__*/_jsx(UIApplication, {
    name: packageName,
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      title: "HubSpot employee access required",
      type: "403",
      children: /*#__PURE__*/_jsx(Text, {
        children: "This app is only available to HubSpot employees. Sign in with a HubSpot employee account to continue."
      })
    })
  });
}
export function renderInternalAuthErrorPage({
  container,
  legacyRoot,
  strictMode
}) {
  return renderAppRoot( /*#__PURE__*/_jsx(InternalAuthErrorPage, {}), {
    container,
    legacyRoot,
    strictMode
  });
}